module.exports = __webpack_public_path__ + "media/src/images/app_icons/ios_splashscreens/iphoneplus_splash-52c5b43a95f2ee1f5e50350a729801fa.png";